import { cn } from '@wolfejs/ui/utils/classnames';

export const Divider = ({ className }: { className?: string }) => (
  <div className={cn('border-default-200 my-4 h-px w-full border-b', className)} />
);
